/*eslint-disable*/

import datepicker from "js-datepicker";

import { slideUp, slideDown, isInDOM, toggleMaskVisibility } from "./helpers";
import {
  loadMatchesByEvents,
  updateActiveTabs,
  updateStaticCalendarBar,
  updateDateArrows,
  updateActiveContainer,
  updateDayTitle,
} from "./Ajax-load-matches";

let btnCalendar = [...document.querySelectorAll(".calendar-button")];
let toggleClass = "active";

// https://www.npmjs.com/package/js-datepicker

function runCalendar() {
  if (!isInDOM(document.querySelector(".qs-datepicker-container"))) {
    const calendarDatepicker = datepicker("#datepicker", {
      disabler: date => checkDateAvailable(date),
      alwaysShow: true,
      customDays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      onSelect: (instance, date) => {
        // Do stuff when a date is selected (or unselected) on the calendar.
        // You have access to the datepicker instance for convenience.

        /* load match click by calendar
			**************************************************************/
        let containers = [...document.querySelectorAll(".matches")];
        for (const i in containers) {
          let event = containers[i].getAttribute("data-event");
          let game = containers[i].getAttribute("data-game");
          let day = moment(date).format("YYYY-MM-DD");
          updateActiveTabs(day);
          let tab;

          let tabActive = document.querySelector(
            ".match-filters__list-item.active"
          );
          if (isInDOM(tabActive)) {
            tab = document
              .querySelector(".match-filters__list-item.active")
              .getAttribute("data-tab");
          }

          loadMatchesByEvents(day, game, event, tab);

          // update Days Static NavBar
          updateStaticCalendarBar(day);

          // update date in the arrows
          day = document
            .querySelector(".days-filter.show button.active")
            .getAttribute("data-view");
          let arrowsParent = document.querySelectorAll(".switch_nav");
          for (let i = 0; i < arrowsParent.length; i++) {
            updateDateArrows(day, arrowsParent[i]);
          }

          updateActiveContainer(day);
          updateDayTitle(day, event);
        }

        document
          .querySelector(".calendar-mobile")
          .classList.remove(toggleClass);
        document
          .querySelector(".calendar-box.mobile-fixed.active")
          .classList.remove(toggleClass);
        slideUp(calendarDatepicker.parent);
        toggleMaskVisibility();
        calendarDatepicker.parent.classList.remove(toggleClass);
        instance.dateSelected = "";
      },
    });

    for (const i in btnCalendar) {
      btnCalendar[i].addEventListener("click", function(e) {
        e.stopPropagation();

        let calendarBox = this.parentElement.parentElement.querySelector(
          ".calendar-box"
        );
        if (calendarBox.classList.contains(toggleClass)) {
          slideUp(calendarDatepicker.calendarContainer);
          calendarBox.classList.remove(toggleClass);
        } else {
          calendarBox.classList.add(toggleClass);
          slideDown(calendarDatepicker.calendarContainer);
        }
      });
    }
  }
}

/* Check available dates before mark in the calendar
**************************************************************/
function checkDateAvailable(date) {
  if (window.location.pathname.split("/")[2] === "tournament") {
    let availableDates = document
      .querySelector(".availableDates")
      .getAttribute("value")
      .split(",");
    date = availableDates.filter(
      item => new Date(item).toLocaleDateString() === date.toLocaleDateString()
    );
    return date.length == 0 ? date : "";
  }
}

export { runCalendar };



// WEBPACK FOOTER //
// ./scripts/modules/Datepicker.js